import { PropTypes } from 'prop-types';

const TrackingParams = (props) => {
  // for additional partners, try to get them to populate the utm_source param with who they are (eg. BroadbandCompare)
  // if they can't do this, add logic here to populate partner
  const partner = props.location.query.utm_source;
  const leadKey = props.location.query.leadKey;
  props.storePartner({ name: partner, leadKey });
  return null;
};

TrackingParams.props = {
  location: PropTypes.object,
  storePartner: PropTypes.func
};

export default TrackingParams;



/** WEBPACK FOOTER **
 ** ./src/components/tracking/TrackingParams/TrackingParams.js
 **/